<div class="container-fluid py-3">
  <div class="row">

    <div class="col-12">

      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="paymentMethodService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [showCurrentPageReport]="true"
        [value]="paymentMethodService.paymentMethods"
        pDroppable="row">

        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Métodos de pago
              </div>
              <div class="col-8 text-end">
                <button
                  (click)="open()"
                  class="btn btn-success rounded-circle me-2">
                  <i class="material-icons mt-1">add</i>
                </button>

                <button
                  (click)="paymentMethodService.getAll()"
                  class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>

                <button
                  class="btn btn-light rounded-circle me-2">
                  <i class="material-icons mt-1">filter_alt_off</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="code">
              Código
              <p-sortIcon field="code"></p-sortIcon>
              <p-columnFilter
                type="text"
                field="code"
                display="menu">
              </p-columnFilter>
            </th>

            <th pSortableColumn="name">
              Nombre
              <p-sortIcon field="name"></p-sortIcon>
              <p-columnFilter
                type="text"
                field="name"
                display="menu">
              </p-columnFilter>
            </th>

            <th pSortableColumn="status">
              Estado
              <p-sortIcon field="status"></p-sortIcon>
            </th>

            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-paymentMethod>
          <tr class="p-selectable-row">

            <td>
              <span class="p-column-title">Código</span>
              {{ paymentMethod.code }}
            </td>

            <td>
              <span class="p-column-title">Nombre</span>
              {{ paymentMethod.name }}
            </td>

            <td>
              <span class="p-column-title">Estado</span>
              @if (paymentMethod.status) {
                <span class="badge rounded-pill text-bg-success">Activo</span>
              } @else {
                <span class="badge rounded-pill text-bg-secondary">Inactivo</span>
              }
            </td>

            <td>
              <button
                (click)="open(paymentMethod)"
                class="btn btn-sm btn-light rounded-circle me-2 my-1">
                <i class="material-icons mt-1">edit</i>
              </button>

              <button
                (click)="delete(paymentMethod)"
                class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>

          </tr>
        </ng-template>

      </p-table>

    </div>

  </div>
</div>
